import { accordionAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const helpers = createMultiStyleConfigHelpers(parts.keys)

const baseStyle = helpers.definePartsStyle({
  container: {
    border: 'none',
    pb: 8,
  },
  button: {
    fontWeight: 'bold',
    borderTop: 'none',
    borderBottom: '1px solid',
    borderBottomColor: 'gray.200',
    px: 0,
    _hover: {
      bg: 'none',
      borderBottomColor: 'primary.400',
    },
  },
  panel: {
    px: 0,
  },
})

export default helpers.defineMultiStyleConfig({ baseStyle })
